import { type Common } from './common.js';
import type * as PatientFeedback from './models/feedback.js';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async upsert(feedback: PatientFeedback.CreateValues): Promise<PatientFeedback.PatientFeedback> {
    const url = this.common.constructPath(`/patient-previsit/feedback`);
    return await this.common.putJSON(url, feedback);
  }
}
